/**
 * Syncs authenticated user to Sentry for error context.
 * Must be rendered inside AuthProvider.
 */
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useAuth } from '../hooks/useAuth';

export function SentryUserSync() {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.preferred_username ?? user.email,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isAuthenticated, user]);

  return null;
}
